import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import GeneralReports from './components/index';
import ScReports from '../ScheduleReport';

type Props = {
  location: {
    pathname: string
  },
};

const Reports = (props: Props) => {
  const {
    location,
  } = props;
  const [current, setCurrent] = useState('reports');

  const setMenu = (query) => {
    switch (query) {
      case '/reports': {
        setCurrent('reports');
        break;
      }
      case '/reports/scheduled-report-attempt': {
        setCurrent('screports');
        break;
      }
      default:
        setCurrent('reports');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="reports">
          <SpTab
            to="/reports"
            selected={current === 'reports'}
          >
            Reports
          </SpTab>
        </Menu.Item>
        <Menu.Item key="screports">
          <SpTab
            to="/reports/scheduled-report-attempt"
            selected={current === 'screports'}
          >
            Scheduled Reports
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/reports" component={GeneralReports} />
        <Route exact path="/reports/scheduled-report-attempt" component={ScReports} />
      </Switch>
    </div>
  );
};

export default withRouter(Reports);
